module.exports = __webpack_public_path__ + "static/media/Rectangle 12892.d5563f48.png";